// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultimate',
  fileSizeLimitTitle: 'The file size cannot exceed 20MB in free version.',
  freeTimesLimitTitle: 'The free trial has run out today.',
  freeImgCutoutTimesLimitTitle:
    "Today's trial opportunity for background removal has been run out, please upgrade to Pro to access all premium features",
  total: 'Total',
  enterCode: 'Enter code',
  signUpToPurchaseBtn: 'Sign Up to Purchase',
  goPurchseBtn: 'Go to Purchase',
  saveTips: 'Save Up to {{num}}%',
  discount: 'Discount',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYear: '$3.75',
  billedMonth: '$29.99 Billed Monthly',
  billedYear: '$179.99 Billed Annually',
  week: 'Week',
  weekly: 'weekly',
  monthly: 'Monthly',
  yearly: 'Annual',
  AlreadySubscribe: 'Already subscribed?',
  vipTips1: 'No file size limits',
  vipTips2: 'No limit to the number of files processed',
  vipTips3: 'Change image backgrounds without limits',
  vipTips4: 'Access to all free tools & premium features',
  purchaseTips: 'Renew automatically and cancel any time.',
  tips: 'Tips:',
  promoCodeInvalidTips: 'Your promo code is invalid',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
